


















import { ScheduleCard } from './components';
import { AppHeading } from '@/uikit';
import { Spinner as LoadingSpinner } from "@/components/spinners";

export default {
  components: { AppHeading, ScheduleCard, LoadingSpinner},
  inject: ['$api'],
  data() {
    return {
      scheduleList: [],
      loading: true,
    };
  },
  computed: {
    isScheduleList(): boolean {
      return this.scheduleList.length > 0;
    },
  },
  async mounted() {
    try {
      let { data: { data }} = await this.$api.get(
        `event/${this.$store.state.event_card.id}/groups?limit=100`
      );
      this.scheduleList = data;
    } catch (e) {
      this.scheduleList = [];
    } finally {
      this.loading = false;
    }
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/tabs/schedule/Schedule.vue